import React, { PureComponent } from 'react';

import { Button, Checkbox, Panel } from '@philips-emr/tws-components';
import { LayoutAlign } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, eventListener, object } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services';

import './hpms-term-service.scss';
import HpmsTermServiceApi from '../../api/hpms-term-service-api';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsTermServiceApi })
export default class HpmsTermService extends PureComponent {
  static DefaultProps = {
    showCheck: true,
  }

  static propTypes = {
    data: object,
    showCheck: bool,
    enabled: bool,
    onSubmitTermUse: eventListener,
  }

  state = {
    check: false,
  }

  getTerm = () => {
    const { data } = this.props;
    return data && (data.term || data.dsTerm);
  }

  submitTermUse() {
    const { onSubmitTermUse } = this.props;

    onSubmitTermUse && onSubmitTermUse();
  }

  onCheck() {
    this.setState({ check: !this.state.check });
  }

  render() {
    const { showCheck, enabled } = this.props;

    return (
      <div className="c-term-service">
        <div className="c-hpms-term-service" dangerouslySetInnerHTML={{ __html: this.getTerm() }}>
        </div>
        {showCheck &&
          (<div className="c-term-service__check">
            <div className="c-term-service__check-checkbox">
            <Panel padding = "1rem 0 1rem 0" >
              <Checkbox
                label={msg('pa.agree-terms')}
                onChange={() => this.onCheck()}
                value={this.state.check}
                enabled={enabled}
              />
              </Panel>
            </div>
            <Panel alignItems = {LayoutAlign.END}>
            <div className="c-term-service__check-button">
              <Button size="xlg"
                value={msg('tws.wizard.confirm')}
                type= "submit"
                enabled={this.state.check}
                onClick={() => this.submitTermUse()} />
            </div>
            </Panel>
          </div>)
        }
      </div>
    );
  }
}
